import React, { useEffect, useState } from "react";
import Table from "../../../../component/table";
import Loader from "react-spinner-loader";
import { sanitizeInput } from "../../../../utils";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import useDebounce from "../../../../Hook/useDebounce";

//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProductDataList,
  addBulkProductionOrder,
} from "../../../../redux/actions/productMaster";
import { getProdcutInventoryData } from "../../../../redux/actions/inventory";
import { GET_PRODUCT_INVENTORY_DATA } from "../../../../redux/constants";

function BulkProductionTable({
  debouncedSearchText,
  buttonClick,
  setButtonClick,
  generateJson,
  update,
  setUpdate,
  tableLoader,
  setTableLoader,
}) {
  const columnsPerPage = 11;
  const columnList = [
    "CW 1",
    "CW 2",
    "CW 3",
    "CW 4",
    "CW 5",
    "CW 6",
    "CW 7",
    "CW 8",
    "CW 9",
  ];
  // State
  const [page, setPage] = useState(1);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [sort, setSort] = useState();
  const [payload, setPayload] = useState([]);
  const [searchResults, setSearchResults] = useState([]);

  // Redux
  const dispatch = useDispatch();
  const { productInventoryData } = useSelector((state) => state.inventory);
  const { allProductData } = useSelector((state) => state.productMaster);

  // Function to get Product List
  const getProductList = () => {
    const request = {
      onError: (error) => {
        setTableLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAllProductDataList(request));
  };

  // Function to get bulk product data
  const getBulkProductData = (productIdWithSequence) => {
    setTableLoader(true);
    const request = {
      tableView: {
        value: "week",
      },
      payload: {
        products: productIdWithSequence,
      },
      onSuccess: () => {
        setTableLoader(false);
      },
      onError: (err) => {
        setTableLoader(false);
      },
    };
    dispatch(getProdcutInventoryData(request));
  };

  // Function to add Bulk Production Data
  const addProductionOrder = () => {
    setTableLoader(true);
    const request = {
      payload,
      onSuccess: () => {
        setUpdate(update + 1);
        setTableLoader(false);
        setButtonClick(false);
        setPayload([]);
      },
      onError: (error) => {
        setTableLoader(false);
        setButtonClick(false);
      },
    };
    // console.log("payload ==>", request.payload);
    dispatch(addBulkProductionOrder(request));
  };

  useEffect(() => {
    if (buttonClick && payload.length > 0) {
      addProductionOrder();
    }
  }, [buttonClick]);

  useEffect(() => {
    getProductList();
  }, []);

  useEffect(() => {
    if (allProductData?.length > 0) {
      const productIdWithSequence = allProductData.map((item, index) => {
        const obj = {
          product_master_id: item.product_master_id,
          sequence: index + 1,
        };
        return obj;
      });
      getBulkProductData(productIdWithSequence);
    }
  }, [allProductData, update]);

  const getTableColumns = () => {
    if (searchResults?.length > 0) {
      const columnData = searchResults[0].weekWise
        .slice(1)
        .slice(
          (page - 1) * columnsPerPage,
          (page - 1) * columnsPerPage + columnsPerPage
        )
        .map((item) => {
          const obj = {
            headName: `Week ${item.weekNumber}`,
            isSort: false,
            value: `Week ${item.weekNumber}`,
          };
          return obj;
        });
      return columnData;
    } else {
      return [
        {
          headName: ``,
          isSort: false,
          value: ``,
        },
      ];
    }
  };

  const calculatePayload = (value_entered, week_no, product_id) => {
    const previousPayloadVal = payload;

    const productObject = productInventoryData.find(
      (item) => item.product_master_id === product_id
    );
    const newProductOrder = productObject.weekWise.map((element) => {
      if (element.weekNumber === week_no) {
        element.productionOrder = value_entered;
      }
      return element;
    });

    // if search text is entered
    const searchObject = searchResults.find(
      (item) => item.product_master_id === product_id
    );
    const newSearchProductOrder = searchObject.weekWise.map((element) => {
      if (element.weekNumber === week_no) {
        element.productionOrder = value_entered;
      }
      return element;
    });

    setSearchResults(searchResults);
    dispatch({
      type: GET_PRODUCT_INVENTORY_DATA,
      payload: productInventoryData,
    });

    const payloadObject = previousPayloadVal.find(
      (element) => element?.weekNumber === week_no
    );

    if (payloadObject) {
      const productObject = payloadObject.products.find(
        (item) => item.product_master_id === product_id
      );
      if (productObject) {
        productObject.qty = Number(value_entered);
      } else {
        payloadObject.products.push({
          product_master_id: product_id,
          qty: Number(value_entered),
        });
      }
    } else {
      const obj = {
        weekNumber: week_no,
        products: [
          {
            product_master_id: product_id,
            qty: Number(value_entered),
          },
        ],
      };
      previousPayloadVal.push(obj);
    }

    setPayload(previousPayloadVal);
  };

  useEffect(() => {
    if (productInventoryData.length > 0) {
      generateJson(productInventoryData);
    }
  }, [productInventoryData]);

  useEffect(() => {
    // console.log('useEffect is called')
    if (debouncedSearchText) {
      setSearchResults(
        productInventoryData.filter((item) =>
          item.product_name
            .toLowerCase()
            .includes(debouncedSearchText.toLowerCase())
        )
      );
    } else {
      // console.log("useEffect inside else condition")
      setSearchResults(productInventoryData);
    }
  }, [debouncedSearchText, productInventoryData]);

  console.log("searchResults ===", {searchResults, productInventoryData, tableLoader})
  console.log('condition --->', tableLoader && searchResults.length > 0);

  return (
    <div>
      {!tableLoader ? (
        <Table
          heads={[
            {
              headName: "Product",
              isSort: true,
              value: "product_name",
            },
            {
              headName: `Current Week ${
                searchResults?.length > 0
                  ? searchResults[0]?.weekWise[0]?.weekNumber
                  : ""
              }`,
              isSort: false,
              value: "name",
            },
            ...getTableColumns(),
            {
              headName: (
                <div className="space-x-2">
                  <span
                    className={`fa-solid fa-chevron-left ${
                      page === 1
                        ? "text-slate-300 pointer-events-none"
                        : "cursor-pointer text-[#9C9C9C]"
                    }  font-semibold`}
                    onClick={(e) => setPage(page - 1)}
                  ></span>
                  <span
                    className={`fa-solid fa-chevron-right ${
                      page ===
                      Math.ceil(
                        searchResults[0]?.weekWise?.length / columnsPerPage
                      )
                        ? "text-slate-300 pointer-events-none"
                        : "cursor-pointer text-[#9C9C9C]"
                    }  font-semibold`}
                    onClick={(e) => {
                      setPage(page + 1);
                    }}
                  ></span>
                </div>
              ),
              isSort: false,
              value: "Action",
            },
          ]}
          tClass="table-auto w-full border-separate border-spacing-y-2"
          hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-100]"
          bClass="text-sm"
          thClass={`px-2 py-3 whitespace-nowrap text-left font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
          setSort={setSort}
          sort={sort}
        >
          {searchResults.length > 0 ? (
            searchResults.map((item, index) => {
              return (
                <>
                  <tr key={index} className="bg-[--bg-color-50]">
                    <td
                      title={item.sku_name}
                      className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 font-semibold text-[#1E293B] text-left rounded-l-md truncate bg-[--bg-color-50]"
                    >
                      {item.product_name}
                      <div className="space-x-1 text-[11px] text-[#1E293B] font-normal tracking-tight">
                        <span>{item.product_no}</span>
                        {item.product_no && <span>&#124;</span>}
                        <span>UOM: {item.uom_name}</span>
                      </div>
                    </td>
                    <td
                      className={`px-2 py-2 text-sm leading-4 tracking-tight text-[#1E293B] text-left truncate bg-[--bg-color-50] font-bold`}
                    >
                      <input
                        type="number"
                        className="form-input w-full text-sm py-0.5"
                        value={item.weekWise[0].productionOrder}
                        onChange={(e) => {
                          const value = sanitizeInput(e.target.value);
                          calculatePayload(
                            value,
                            item.weekWise[0].weekNumber,
                            item.product_master_id
                          );
                        }}
                      />
                    </td>

                    {item.weekWise
                      .slice(1)
                      .slice(
                        (page - 1) * columnsPerPage,
                        (page - 1) * columnsPerPage + columnsPerPage
                      )
                      .map((week_data, index) => {
                        return (
                          <td
                            className={`px-2 py-2 text-sm leading-4 tracking-tight text-[#1E293B] text-left truncate bg-[--bg-color-50]`}
                          >
                            <input
                              type="number"
                              name={week_data.weekName}
                              className="form-input w-full text-sm py-0.5"
                              onChange={(e) => {
                                const value = sanitizeInput(e.target.value);
                                calculatePayload(
                                  value,
                                  week_data.weekNumber,
                                  item.product_master_id
                                );
                              }}
                              value={week_data.productionOrder}
                            />
                          </td>
                        );
                      })}

                    <td className="px-2 py-2 text-sm leading-4 tracking-tight text-[#1E293B] text-left truncate rounded-r-md bg-[--bg-color-50]"></td>
                  </tr>
                </>
              );
            })
          ) : (
            <tr className="px-2 py-3 whitespace-nowrap">
              <td
                colSpan={columnList.length + 3}
                className="text-center py-2 text-lg text-[#1E293B] tracking-tight leading-4"
              >
                There are no records to display
              </td>
            </tr>
          )}
        </Table>
      ) : (
        <div className="w-full">
          <Loader show={tableLoader} />
        </div>
      )}
    </div>
  );
}

export default BulkProductionTable;
